import React from 'react';
import './Education.css';

const Education = ({ education = [] }) => {
  const toPeriod = (start, end) => {
    if (!start && !end) return '';
    return `${start || ''} ${end ? `- ${end}` : '- Present'}`.trim();
  };

  return (
    <section id="education" className="education">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Education & Certifications</h2>
        </div>

        <div className="education-timeline">
          {education.map((edu, index) => (
            <div key={index} className="education-item">
              <div className="education-marker">
                <div className="marker-dot"></div>
                {index < education.length - 1 && <div className="marker-line"></div>}
              </div>

              <div className="education-content">
                <div className="education-card">
                  <div className="education-header">
                    <h3 className="education-degree">{edu.degree}</h3>
                    <div className="education-school">{edu.school || edu.institution}</div>
                    <div className="education-period">{edu.period || toPeriod(edu.start_date, edu.end_date)}</div>
                  </div>

                  {edu.description ? (<p className="education-description">{edu.description}</p>) : null}

                  {edu.achievements && edu.achievements.length > 0 && edu.achievements.some(ach => (ach.achievement || ach) && String(ach.achievement || ach).trim() !== '') && (
                    <div className="education-achievements">
                      <h4 className="achievements-title">Key Highlights:</h4>
                      <ul className="achievements-list">
                        {(edu.achievements || []).filter(ach => (ach.achievement || ach) && String(ach.achievement || ach).trim() !== '').map((achievement, idx) => (
                          <li key={idx} className="achievement-item">
                            <span className="achievement-icon">🎓</span>
                            {achievement.achievement || achievement}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;

